<template>


	<div>

		<!-- Header -->
		<header id="header">
			<div class="header">
<!--				<div class="header_top">
					<a href="https://www.ssflex.co.kr" class="logo_ssf"><img src="/ssflex_cs1/assets/img/common/logo_ssflex.png" alt="sangsangflex"></a>
				</div>-->
				<div class="header_bottom">
					<h1 class="logo_client">
						<!--						<a href="#"><img src="/ssflex_cs1/assets/img/temp/logo_gansam.png" alt="gansam"></a>-->
						<a href="/"><img :src="APIs.API_URL + '/coinfos/' + getCocode() + '/logo'" :alt="coInfoVO.coName"></a>
					</h1>
					<nav class="gnb">
						<ul class="dep1">
							<li>
								<strong>Trend</strong>
								<ul class="dep2">
									<li>
										<router-link to="/app/board/news_feeds">뉴스피드</router-link>
									</li>
									<li>
										<router-link to="/app/board/trend_events">이벤트</router-link>
									</li>
									<li>
										<router-link to="/app/board/success_examples">성공사례</router-link>
									</li>
								</ul>
							</li>
							<li>
								<strong>Support Services</strong>
								<ul class="dep2">
									<li>
										<router-link to="/app/board/guide_install">설치 가이드</router-link>
									</li>
									<li>
										<router-link to="/app/board/guide_function">기능 가이드</router-link>
									</li>
									<li>
										<router-link to="/app/board/issue">이슈 AtoZ</router-link>
									</li>
									<li>
										<router-link to="/app/board/faq">FAQ</router-link>
									</li>
								</ul>
							</li>
							<li>
								<strong>E-Learning Services</strong>
								<ul class="dep2">
									<li v-for="(item, index) in eduMenus"><a :href="'/app/education/main/' + item.code">{{ item.codeName }}</a></li>
									<li>
										<router-link to="/app/board/dynamo_factory">Dynamo Factory</router-link>
									</li>
								</ul>
							</li>
							<li>
								<strong>Community</strong>
								<ul class="dep2">
									<li>
										<router-link to="/app/board/site_notice">공지사항</router-link>
									</li>
									<li>
										<router-link to="/app/board/company">커뮤니티</router-link>
									</li>
									<li>
										<router-link to="/app/board/company_anonymous">플랫폼 요청사항</router-link>
									</li>
									<li style="width: 120%;">
										<router-link to="/app/board/technical">상상진화 기술지원센터</router-link>
									</li>
								</ul>
							</li>
						</ul>
						<div class="gnb_bg" style="height: 133px;"></div>
					</nav>
					<div class="util">
						<button type="button" class="btn_search"><span class="blind">검색</span></button>
						<button type="button" class="btn_menu"><img src="/ssflex_cs1/assets/img/common/ico/ico_menu.svg" alt="메뉴"></button>

						<router-link to="/member/login" class="btn_login" v-if="!isLogin()">Login</router-link>
						<router-link to="/mypage" class="btn_login" v-else-if="isLogin()">My Page</router-link>
					</div>
				</div>
			</div>
			<!-- Total search-->
			<div class="total_search">
				<form @submit.prevent="doSearch">
					<div class="container">
						<div class="search_box">
							<input type="text" class="inp_search" placeholder="검색어를 입력해주세요" v-model="searchText">
							<button type="submit" class="btn_search"><img src="/ssflex_cs1/assets/img/common/ico/ico_search.svg" alt="검색"></button>
						</div>
					</div>
				</form>
			</div>
		</header>

		<!-- Mobile menu -->
		<nav class="mobile_menu">
			<div class="panel">

				<ul class="util" v-if="!isLogin()">
					<li>
						<router-link to="/member/login">Login</router-link>
					</li>
					<li>
						<router-link to="/member/joinStart">Join Us</router-link>
					</li>
				</ul>
				<ul class="util" v-else>
					<li>
						<router-link to="/mypage">My Page</router-link>
					</li>
					<li><a href="javascript:" @click="doLogout">Log Out</a></li>
				</ul>

				<ul class="menu">
					<li>
						<strong>Trend</strong>
						<ul class="dep2">
							<li>
								<router-link to="/app/board/news_feeds">뉴스피드</router-link>
							</li>
							<li>
								<router-link to="/app/board/trend_events">이벤트</router-link>
							</li>
							<li>
								<router-link to="/app/board/success_examples">성공사례</router-link>
							</li>
						</ul>
					</li>
					<li>
						<strong>Support Services</strong>
						<ul class="dep2">
							<li>
								<router-link to="/app/board/guide_install">설치 가이드</router-link>
							</li>
							<li>
								<router-link to="/app/board/guide_function">기능 가이드</router-link>
							</li>
							<li>
								<router-link to="/app/board/issue">이슈 AtoZ</router-link>
							</li>
							<li>
								<router-link to="/app/board/faq">FAQ</router-link>
							</li>
						</ul>
					</li>
					<li>
						<strong>E-Learning Services</strong>
						<ul class="dep2">
							<li v-for="(item, index) in eduMenus">
								<router-link :to="'/app/education/main/' + item.code">{{ item.codeName }}</router-link>
							</li>
							<li>
								<router-link to="/app/board/dynamo_factory">Dynamo Factory</router-link>
							</li>
						</ul>
					</li>
					<li>
						<strong>Community</strong>
						<ul class="dep2">
							<li>
								<router-link to="/app/board/site_notice">공지사항</router-link>
							</li>
							<li>
								<router-link to="/app/board/company">커뮤니티</router-link>
							</li>
							<li>
								<router-link to="/app/board/company_anonymous">플랫폼 요청사항</router-link>
							</li>
							<li >
								<router-link to="/app/board/technical">상상진화 기술지원센터</router-link>
							</li>
						</ul>
					</li>
				</ul>
				<button type="button" class="btn_close"><img src="/ssflex_cs1/assets/img/common/ico/ico_close.svg" alt="메뉴 닫기"></button>
			</div>
		</nav>


	</div>


</template>


<script>

import HWAPP from '@/commons/mixins/hwapp.mixin'
import SessionMixin from '@/commons/mixins/sessions.mixin'
import webUtils from "@/commons/utils/web.utils";
import $ from "jquery";

export default {
	name: "cs1Header",
	mixins: [
		HWAPP, SessionMixin
	],
	data() {


		return {

			pathname: location.pathname,

			coInfoVO: new this.CoInfo(),
			keywordVO: new this.KeywordVO(),
			keywordList: [],

			searchText: "",

			eduMenus: [],

			isShowShopping: true,
			isShowSnsLogin: true

		}
	},
	beforeCreate() {
		let self = this

		window.onload = function () {
			// if (location.hash.length > 0) {
			// 	try {
			// 		// hex code to string
			// 		const htos = (s) => {
			// 			let j
			// 			let h = s.match(/.{1,4}/g) || []
			// 			let b = ""
			// 			for(j = 0; j < h.length; j++) { b += String.fromCharCode(parseInt(h[j], 16)) }
			// 			return b
			// 		}
			//
			// 		self.$session.set("HWSSessions", decodeURI(htos(atob(location.hash.replace("#", "")))))
			// 		history.replaceState("", document.title, window.location.pathname + window.location.search)
			// 		location.reload()
			// 		// eslint-disable-next-line no-empty
			// 	} catch (e) {
			// 	}
			// }

			window.addEventListener('message', event => {
				let allowOrigin = event.origin

				if (event.data.caidx != null) {
					allowOrigin = allowOrigin.replace(webUtils.getSubdomain(), event.data.coCode)

					if (event.origin === new URL(allowOrigin).origin) {
						self.$session.set("HWSSessions", event.data)
						self.webUtils.goWithCoCode(self)
					}
				}

				if (event.data.key === "alert") {
					self.swalUtils.gritter(event.data.title, event.data.content, event.data.icon, 1500)
				}

				if (event.data.key === "go") {
					location.href = event.data.to
				}

				if (event.data.key === 'apple') {
					self.$session.set("HWSSessions", event.data.account)
					self.goWithCoCode(self)
				}
			}, false)

			const jQuery = window.jQuery
			const $ = window.$

			const resetJqEv = (fn, listener, ...jqNode) => {
				jqNode.forEach(e => {
					Array(e).forEach(e => {
						let ev = (jQuery._data || jQuery.data)($(e)[0], 'events')
						if (ev) {
							let key = Object.keys(ev)
							key.forEach(e => {
								delete ev[e]
							})
						}
					})
					e[listener](fn)
				})
			}

			resetJqEv(
				() => {
					$('.mobile_menu').stop().fadeIn()
					$('.dim').css("z-index", "998").stop().fadeIn()
					$('.total_search').css('display', 'none').stop()
					$('.btn_search.active').removeClass('active')
				}
				, 'click'
				, $('.btn_menu')
			)

			resetJqEv(
				e => {
					if ($(e.target)[0] !== $('.mobile_menu').children('.panel')[0] && $('.mobile_menu').children('.panel').find($(e.target)).not('.btn_close img').length === 0) {
						$('.mobile_menu').stop().fadeOut()
						$('.dim').fadeOut(e => {
							setTimeout(() => {
								$(e).css('display', 'none').stop()
							})
						})
					}
				}
				, 'click'
				, $('.mobile_menu')
				, $('.mobile_menu .btn_close')
			)

			resetJqEv(
				e => {
					if ($(e.target).hasClass('active')) {
						$('.total_search').stop().fadeOut()
						$('.btn_search.active').removeClass('active')
						$('.dim').fadeOut(e => {
							setTimeout(() => {
								$(e).css('display', 'none').stop()
							})
						})
					} else {
						$('.total_search').stop().fadeIn(() => {
							$('.total_search').find("input").focus()
						})
						$('.dim').css("z-index", "99").stop().fadeIn()
						$('.btn_search').not('.search_box .btn_search').addClass('active')
					}
				}
				, 'click'
				, $('.btn_search').not('.search_box .btn_search')
			)

			resetJqEv(
				() => {
					$('.total_search').stop().fadeOut()
					$('.btn_search.active').removeClass('active')
					$('.dim').fadeOut(e => {
						setTimeout(() => {
							$(e).css('display', 'none').stop()
						})
					})
				}
				, 'click'
				, $('.dim')
			)
		}
	},
	async created() {

		this.getCompanyInfo();
		this.getKeywords();

		try {
			this.eduMenus = []
			const eduCodeVO = await this.getCodeOne("2001");
			await Promise.all(
				eduCodeVO.children.forEach((eduCodeVO) => {
					const tmp = {
						code: eduCodeVO.code,
						codeName: eduCodeVO.codeName,
					}
					this.eduMenus.push(tmp);
				}),
			)
		} catch (e) {
		}

		/**
		 * google analytics
		 */
		// <!-- Google tag (gtag.js) -->
		this.$loadScript("https://www.googletagmanager.com/gtag/js?id=G-893ZD679HL").then(() => {
			console.log('https://www.googletagmanager.com/gtag/js?id=G-893ZD679HL')
			window.dataLayer = window.dataLayer || [];
			function gtag(){window.dataLayer.push(arguments);}
			gtag('js', new Date());

			gtag('config', 'G-893ZD679HL');
		})
	},
	mounted() {


	},
	methods: {
		snsOpen(url) {
			const temp = {
				isCloseBTN: "Y",
				url: url,
			}
			this.appOpen(temp);
		},

		async getCompanyInfo() {

			var self = this

			try {
				self.coInfoVO = await self.getCoInfoVO()
				if (self.coInfoVO.logo == null) {
					self.coInfoVO.logo = "/assets/img/temp/temp_logo.svg";
				}

				// 아이폰이 경우 사이트 설정 따라가게 설정
				if (self.appDevice() === "IOS") {
					self.isShowShopping = self.coInfoVO.isIosShop
					self.isShowSnsLogin = self.coInfoVO.isIosSns
				}
			} catch (e) {
			}

			/*this.axiosCaller.get(this, this.APIs.CO_INFO + "/" + this.webUtils.getSubdomain(), {}, (res) => {
				const result = res.data
				if (result.status === "ok") {
					self.coInfoVO = result.coInfoVO
					if (self.coInfoVO.logo == null) {
						self.coInfoVO.logo = "/assets/img/temp/temp_logo.svg";
					}
					console.log(self.coInfoVO)
				} else {
					console.log(result.msg)
				}
			})*/
		},


		getKeywords() {

			var self = this
			this.axiosCaller.get(this, this.APIs.DP_KEYWORD + "/search_all", {}, (res) => {
				const result = res.data
				console.log(result)
				if (result.status === "ok") {
					if (result.keywordVO != null) {
						self.keywordVO = result.keywordVO
						self.keywordList = self.keywordVO.keywords.split(",")
						if (self.keywordVO.searchOption === 'V') {
							self.searchText = self.keywordVO.inputValue
						}
					}
				} else {
					console.log(result.msg)
				}
			})

		},


		doSearch() {

			$('.btn_search.active').click()

			if (this.searchText.length === 0) {
				this.swalUtils.fire("검색어를 입력해 주세요.", "", "question")
			} else {
				webUtils.goTo(this, `/app/searcher/${this.stringUtils.toBase64(this.searchText)}`)
			}
		},


	},
	watch: {
		$route() {
			$('.mobile_menu').stop().fadeOut()
			$('.dim').fadeOut(e => {
				setTimeout(() => {
					$(e).css('display', 'none').stop()
				})
			})
			// Object.assign(this.$router.currentRoute.query, { _r: new Date().getTime() })
			// delete this.$router.currentRoute.query._r
		}
	}

}
</script>

<style scoped>

</style>
